<template>
  <app-main-layout>
    <!--  -->
    <template v-slot:top-nav>
      <app-top-nav />
    </template>
    <!--  -->
    <template v-slot:main>
      <div>
        <AppHomeTop />
        <div>
          <!-- <app-how-it-works /> -->
        </div>
      </div>
    </template>
    <!--  -->
    <template v-slot:footer>
      <app-main-footer />
    </template>
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import AppHomeTop from "./home-top.vue";

@Options({
  components: {
    AppHomeTop,
  },
})
export default class extends Vue {}
</script>

<style lang="scss"></style>
